// TR
export const locale = {
    common: {
        fixed: "Sabit",
        percent: "Yüzde",
        user: "Kullanıcı",
        company: "Şirket",
        customer: "Müşteri",
        deleted: "Silindi",
        detail: "Detay",
        edit: "Düzenle",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        new: "Yeni",
        back: "Geri",
        language: "Dil",
        currency: "Para Birimi",
        cancel: "Vazgeç",
        send: "Gönder",
        confirm: "Devam Et",
        date: "Tarih",
        save: "Kaydet",
        report: "Bildir",
        active: "Aktif",
        passive: "Pasif",
        licenceExpired: "Lisans Süresi Dolmuş",
        clickToUpload: "Yüklemek için tıklayın",
        notificationCount: "Bildirim Sayısı",
        remove: "Sil",
        action: "İşlem",
        search: "Ara",
        ok: "Tamam",
        close: "Kapat",
        preview: "Önizleme",
        today: "Bugün",
        daily: "Günlük",
        weekly: "Haftalık",
        monthly: "Aylık",
        quarterly: "3 Aylık",
        semi_annual: "6 Aylık",
        yearly: "Yıllık",
        month: "Ay",
        day: "Gün",
        year: "Yıl",
        week: "Hafta",
        viewAll: "Tümü",
        notification: "Bildirim",
        download: "İndir",
        optional: "Opsiyonel",
        permission: "Yetki",
        manager: "Yönetici",
        default: "Varsayılan",
        status: "Durum",
        sort: "Sıra",
        createdAt: "Oluşturulma Tarihi",
        createdAtShort: "Oluşturulma",
        chooseSelect: "Seçim yapın.",
        chooseSelectShort: "Seçiniz",
        chooseOption: "Özellik seçimi yapın",
        canChooseOption: "Özellik seçimi yapabilirsiniz",
        chooseDate: "Tarih seçimi yapın.",
        chooseTime: "Saat seçimi yapın.",
        chooseDateAndTime: "Tarih ve saat seçimi yapın.",
        individual: "Bireysel",
        corporate: "Kurumsal",
        cash: "Peşin",
        system: "Sistem",
        export: "Dışa Aktar",
        overview: "Genel Bakış",
        settings: "Ayarlar",
        credentials: "Kimlik Bilgileri",
        homePage: "Anasayfa",
        id: "ID",
        true: "Doğru",
        false: "Yanlış",
        hour: "Saat",
        minute: "Dakika",
        second: "Saniye",
        empty: "Boş",
        indefinite: "Süresiz",
        ipAddress: "İp Adresi",
        userAgent: "User Agent",
        immediately: "Hemen",
        exportTooltip: "Filtreleme yapılmadığında liste maksimum 1.000 kayıt olarak sınırlandırılacaktır.",
        translation: "Çeviri",
        weather_word: "Hava",
        condition_word: "Durumu",
        storage: {
            quotaNotFound: 'Bir depolama planına sahip değilsiniz. Lütfen bir depolama planı satın alınız.',
            quotaExceeded: 'Depolama alanınız doldu. Lütfen depolama planınızı yükseltin veya yer açın.',
        },
        panelSettings: {
            alwaysOnTop: 'Her zaman üstte',
            openOnLoad: 'Pencere açık gelsin',
            resetWindowSize: 'Pencere Boyutunu Sıfırla',
            resetInnerLayout: 'İç Düzeni Sıfırla',
            transparent: 'Arkaplanı saydamlaştır',
        },
        dock: {
            minimize: 'Küçült',
            autoHide: "Dock'u otomatik gizle",
            customize: "Dock'u Özelleştir...",
            removeFromDock: "Dock'tan Kaldır",
            close: 'Kapat',
            pages: 'Sayfalar',
            panels: 'Paneller',
            settings: 'Ayarlar',
            magnification: 'Büyütme efekti',
            magnificationScale: 'Büyütme',
            clickAnimation: 'Tıklama efekti',
            bounceAnimation: 'Zıplama efekti',
            bounceOnOpen: 'Uygulama açılışında zıplat',
            positionBottom: 'Aşağı',
            positionRight: 'Sağ',
            position: 'Konum',
            resetOrder: 'Öğe Sırasını Sıfırla',
            resetCustomizations: 'Boyutu ve Ayarları Sıfırla',
            weatherAnimation: 'Animasyon',
            musicAnimation: 'Animasyon',
            musicStop: 'Müziği Durdur ve Kapat',
        },
        spotlight: {
            title: 'Spotlight',
            placeholder: 'Müşteri, araç, ürün, not ara...',
            noResults: 'Sonuç bulunamadı',
            emptyState: 'Sonuçları görmek için arayın..',
            keepTyping: 'Aramak için yazmaya devam edin...',
            copied: 'Kopyalandı',
            currencyError: 'Kur bilgisi alınamadı',
            stockQty: 'Stok: {count}',
            noPaymentInfo: 'Ödeme bilgisi yok',
            fileOrphan: 'Bağımsız dosya',
            fileMultipleRelations: 'Bu dosya birden fazla yerde kullanılıyor. Hangisini açmak istersiniz?',
            subfolder: 'Alt klasör',
            remaining: 'kalan',
            quickActions: {
                prefix: 'yeni',
                title: 'Hızlı İşlemler',
                newNote: 'Yeni Not Oluştur',
                newEvent: 'Yeni Etkinlik Oluştur',
                newVWO: 'Yeni Araç İş Emri',
                newSWO: 'Yeni Servis İş Emri',
                newCustomer: 'Yeni Müşteri',
                newOfficer: 'Yeni Çalışan',
                hintNote: 'Not panelini aç',
                hintAgenda: 'Ajanda panelini aç',
                hintVWO: 'Araç iş emri oluştur',
                hintSWO: 'Servis iş emri oluştur',
                hintCustomer: 'Müşteri kaydı oluştur',
                hintOfficer: 'Çalışan kaydı oluştur',
                keywordsNote: 'not,note',
                keywordsAgenda: 'ajanda,etkinlik,takvim,randevu',
                keywordsVWO: 'iş emri,is emri,servis,araç iş,araç servis',
                keywordsSWO: 'iş emri,is emri,servis',
                keywordsCustomer: 'müşteri,musteri,customer',
                keywordsOfficer: 'çalışan,calisan,personel,yetkili',
            },
            groups: {
                CUSTOMERS: 'Müşteriler',
                VEHICLES: 'Araçlar',
                OFFICERS: 'Yetkililer',
                STOCKS: 'Ürünler',
                USERS: 'Kullanıcılar',
                COMPANIES: 'Şirketler',
                MODULE_VEHICLE_WORK_ORDER: 'İş Emirleri',
                MODULE_NOTE: 'Notlar',
                MODULE_AGENDA: 'Ajanda',
                MODULE_WEATHER: 'Hava Durumu',
                FILES: 'Dosyalar',
                FILE_FOLDERS: 'Dosya Klasörleri',
                MODULE_MUSIC_TRACKS: 'Parçalar',
                MODULE_MUSIC_PLAYLISTS: 'Çalma Listeleri',
            },
            weather: {
                pending: 'Hava durumu yükleniyor...',
                feelsLike: 'Hissedilen',
                tomorrow: 'Yarın'
            },
            guide: {
                title: 'Spotlight Kullanım Kılavuzu',
                searchTitle: 'Genel Arama',
                searchDesc: 'Müşteri, araç, ürün, not, ajanda ve iş emri gibi tüm kayıtlarda arama yapın. En az 2 karakter yazmanız yeterli.',
                prefixTitle: 'Özel Arama (Prefix)',
                prefixDesc: 'Sadece belirli bir kategoride arama yapmak için başına kısa kod ekleyin.',
                prefixCustomer: 'Müşteri',
                prefixVehicle: 'Araç',
                prefixStock: 'Ürün',
                prefixWorkOrder: 'İş Emri',
                prefixNote: 'Not',
                prefixAgenda: 'Ajanda',
                prefixDemoTerm: 'Berkay',
                prefixDemoDesc: 'Müşterilerde "Berkay" aranır',
                exampleCustomer: 'Berkay Aksoy',
                exampleVehicle: '34 ABC 123',
                exampleStock: 'Şarj Aleti',
                mathTitle: 'Matematik Hesaplama',
                mathDesc: 'Doğrudan matematik işlemi yazarak anında sonuç alın. Sonuca tıklayarak kopyalayabilirsiniz.',
                currencyTitle: 'Döviz Çevirme',
                currencyDesc: 'Tutarın yanına para birimi sembolü veya kodu yazarak anlık kur çevirimi yapın.',
                unitTitle: 'Birim Çevirme',
                unitDesc: 'Uzunluk, ağırlık, hacim, sıcaklık, veri ve zaman birimlerini anında çevirin.',
                unitEx1Input: '1kg kaç gram',
                unitEx1Result: '1.000 g',
                unitEx2Input: '5 mil kaç km',
                unitEx2Result: '8,05 km',
                unitEx3Input: '100 fahrenheit -> celsius',
                unitEx3Result: '37,78 °C',
                unitEx4Input: '3600 sn kaç dk',
                unitEx4Result: '60 dk',
                prefixWeather: 'Hava Durumu',
                weatherTitle: 'Hava Durumu',
                weatherDesc: 'Şehir adı yazarak anlık hava durumu bilgisini görüntüleyin. Prefix veya doğal dil ile arama yapabilirsiniz.',
                weatherEx1Input: 'hava:bolu',
                weatherEx1Result: 'Bolu hava durumu',
                weatherEx2Input: 'istanbul hava',
                weatherEx2Result: 'İstanbul hava durumu',
                weatherEx3Input: 'ankara kaç derece',
                weatherEx3Result: 'Ankara sıcaklık',
                weatherPrefixLabel: 'Hava durumu',
                weatherPrefixShort: 'Kısa prefix',
                shortcutsTitle: 'Klavye Kısayolları',
                shortcutToggle: 'Spotlight aç/kapat',
                shortcutNavigate: 'Sonuçlar arası gezin',
                shortcutSelect: 'Seçili sonucu aç',
                shortcutEsc: 'Aramayı temizle / kapat',
            },
        },
        weather: {
            title: 'Hava Durumu',
            sidebar: 'Kenar Çubuğu',
            search: 'Şehir ara...',
            addLocation: 'Konum Ekle',
            detectLocation: 'Konumumu Bul',
            myLocation: 'Konumum',
            setDefault: 'Varsayılan Yap',
            removeLocation: 'Kaldır',
            noLocations: 'Henüz konum eklenmedi',
            maxLocations: 'Konum ekleme sınırına ulaşıldı',
            removeConfirm: 'konumu kaldırılsın mı?',
            noResults: 'Sonuç bulunamadı',
            hourly: 'Saatlik Tahmin',
            daily: '7 Günlük Tahmin',
            details: 'Detaylar',
            now: 'Şu An',
            humidity: 'Nem',
            wind: 'Rüzgar',
            uvIndex: 'UV İndeksi',
            pressure: 'Basınç',
            visibility: 'Görüş Mesafesi',
            sunrise: 'Gün Doğumu',
            sunset: 'Gün Batımı',
            feelsLike: 'Hissedilen',
            high: 'Y',
            low: 'D',
            refresh: 'Yenile',
            today: 'Bugün',
            loading: 'Yükleniyor...',
            locationError: 'Konum alınamadı',
            changeCity: 'Şehir Değiştir',
            precipChance: 'Yağış',
            sunriseShort: 'G.Doğumu',
            sunsetShort: 'G.Batımı',
            days: {
                mon: 'Pzt',
                tue: 'Sal',
                wed: 'Çar',
                thu: 'Per',
                fri: 'Cum',
                sat: 'Cmt',
                sun: 'Paz',
            },
            animations: 'Animasyonlar',
            accumulation: 'Birikme Efekti',
        },
        music: {
            title: 'Müzik',
            sidebar: 'Kenar Çubuğu',
            radio: 'Radyo',
            library: 'Kütüphane',
            myMusic: 'Müziğim',
            favorites: 'Favoriler',
            popular: 'Popüler',
            genres: 'Türler',
            recentlyPlayed: 'Son Çalınanlar',
            search: 'Radyo ara...',
            searchShort: 'Ara',
            nowPlaying: 'Şu An Çalınıyor',
            notPlaying: 'Henüz bir istasyon seçilmedi',
            addFavorite: 'Favorilere Ekle',
            removeFavorite: 'Favorilerden Çıkar',
            noFavorites: 'Henüz favori istasyon yok',
            noFavoritesHint: 'Beğendiğiniz istasyonları favorilere ekleyin',
            noResults: 'Sonuç bulunamadı',
            noResultsHint: 'Farklı bir arama terimi deneyin',
            animations: 'Animasyonlar',
            buffering: 'Bağlanılıyor...',
            streamError: 'Yayın bağlantısı kurulamadı',
            stop: 'Durdur',
            genrePop: 'Pop',
            genreRock: 'Rock',
            genreTurkish: 'Türkçe',
            genreJazz: 'Caz',
            genreClassical: 'Klasik',
            genreFolk: 'Halk Müziği',
            genreArabesk: 'Arabesk',
            genreNews: 'Haber',
            playlists: 'Çalma Listeleri',
            tracks: 'Şarkı',
            kbps: 'kbps',
            libraryComingSoon: 'Kütüphane yakında aktif olacak',
            noTracks: 'Henüz ses dosyası yok',
            noTracksHint: 'Yükle butonuyla ses dosyası ekleyebilirsiniz',
            loadMore: 'Daha Fazla',
            renamePlaylist: 'Yeniden Adlandır',
            deletePlaylist: 'Sil',
            deletePlaylistConfirm: '{name} listesini silmek istediğinize emin misiniz? Şarkılar kütüphanede kalır.',
            playlistName: 'Liste adı',
            searchTracks: 'Şarkı ara...',
            newPlaylist: 'Yeni Çalma Listesi',
            addToPlaylist: 'Çalma Listesine Ekle',
            removeFromPlaylist: 'Listeden Çıkar',
            addedToPlaylist: 'Listeye eklendi',
            upload: 'Yükle',
            refresh: 'Yenile',
            collapse: 'Küçült',
            shuffle: 'Karıştır',
            repeat: 'Yinele',
            repeatAll: 'Tümünü Yinele',
            repeatOne: 'Bir Şarkıyı Yinele',
            favorite: 'Favori',
            selectMode: 'Seç',
            selected: 'seçili',
            deleteTrack: 'Sil',
            selectAll: 'Tümünü Seç',
            trackUnit: 'şarkı',
            detail_artist: 'Sanatçı',
            detail_album: 'Albüm',
            detail_genre: 'Tür',
            detail_year: 'Yıl',
            detail_format: 'Format',
            detail_size: 'Boyut',
            noPlaylists: 'Henüz çalma listesi yok',
        },
        fileManager: {
            title: 'Dosya Yöneticisi',
            titlePicker: 'Dosya Yönetimi',
            selectFile: 'Dosya Seç',
            refresh: 'Yenile',
            sidebar: 'Kenar Çubuğu',
            categories: 'Kategoriler',
            allFiles: 'Tüm Dosyalar',
            noteAttachments: 'Not Ekleri',
            workOrderAttachments: 'İş Emri Ekleri',
            musicFiles: 'Müzik Dosyaları',
            playlistFiles: 'Çalma Listeleri',
            independentFiles: 'Bağımsız Dosyalar',
            trash: 'Çöp Kutusu',
            folders: 'Klasörler',
            expandAll: 'Tümünü Aç',
            collapseAll: 'Tümünü Kapat',
            newFolder: 'Yeni Klasör',
            newSubFolder: 'Yeni Alt Klasör',
            folderName: 'Klasör adı',
            noFolders: 'Henüz klasör yok',
            noResults: 'Sonuç bulunamadı',
            trashEmpty: 'Çöp kutusu boş',
            folderEmpty: 'Bu klasör boş',
            moduleEmpty: 'Henüz içerik yok',
            trashHint: 'Silinen dosyalar burada görüntülenir',
            uploadHint: 'Dosya sürükleyin veya yükle butonunu kullanın',
            name: 'Ad',
            size: 'Boyut',
            type: 'Tür',
            date: 'Tarih',
            folder: 'Klasör',
            preview: 'Dosya Bilgisi',
            autoPreview: 'Önizleme',
            download: 'İndir',
            open: 'Aç',
            navigateToContent: 'İçeriğe Git',
            restore: 'Geri Yükle',
            permanentDelete: 'Kalıcı Sil',
            rename: 'Yeniden Adlandır',
            changeColor: 'Renk Değiştir',
            move: 'Taşı',
            uploadFile: 'Dosya Yükle',
            selectAll: 'Tümünü Seç',
            rootDirectory: 'Kök Dizin',
            deleteConfirmTitle: 'Silme Onayı',
            deleteConfirmSingle: 'Bu öğeyi silmek istediğinizden emin misiniz?',
            deleteConfirmMultiple: '{count} öğeyi silmek istediğinizden emin misiniz?',
            emptyTrash: 'Çöp Kutusunu Boşalt',
            emptyTrashConfirm: 'Çöp kutusundaki tüm öğeler kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            continue: 'Devam Et',
            restoreAll: 'Tümünü Geri Yükle',
            restoreAllConfirm: 'Çöp kutusundaki tüm öğeler geri yüklenecek.',
            permanentDeleteTitle: 'Kalıcı Silme',
            permanentDeleteSingle: 'Bu öğe kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            permanentDeleteMultiple: '{count} öğe kalıcı olarak silinecek. Bu işlem geri alınamaz.',
            depthLimitTitle: 'Klasör Sınırı',
            depthLimitMessage: 'Maksimum klasör derinliğine ulaşıldı.',
            depthLimitParent: 'Maksimum klasör derinliğine ulaşıldı. Bir üst klasöre eklemek ister misiniz?',
            depthLimitMove: 'Maksimum klasör derinliği aşıldığı için bu işlem tamamlanamıyor.',
            addToParent: 'Ekle',
            whichWorkOrder: 'Hangi İş Emri kaydına yüklenecek?',
            workOrderPrefix: 'İş Emri #',
            items: 'öğe',
            filesSelected: '{count} dosya seçildi',
            itemsSelected: 'öğe seçildi',
            select: 'Seç',
            statsFiles: '{count} dosya',
            statsFolders: '{count} klasör',
            statsFilesAndFolders: '{files} dosya, {folders} klasör',
            statsTemplate: '{files} dosya, {folders} klasör',
            pdfFile: 'PDF dosyası',
            pdfPreview: 'PDF Önizle',
            videoFile: 'Video dosyası',
            audioFile: 'Ses dosyası',
            goToContent: 'İçeriğe Git',
            metaSize: 'Boyut',
            metaType: 'Tür',
            fileType_image: 'Resim',
            fileType_pdf: 'PDF Belgesi',
            fileType_document: 'Belge',
            fileType_spreadsheet: 'Hesap Tablosu',
            fileType_archive: 'Arşiv',
            fileType_video: 'Video',
            fileType_audio: 'Ses',
            fileType_generic: 'Dosya',
            metaCreated: 'Oluşturulma',
            metaModified: 'Değiştirilme',
            metaModule: 'Modül',
            metaResolution: 'Çözünürlük',
            metaDuration: 'Süre',
            metaCamera: 'Kamera',
            metaExposure: 'Pozlama',
            metaTakenAt: 'Çekim Tarihi',
            metaGps: 'Konum',
            metaCodec: 'Ses Codec',
            metaPages: 'Sayfa',
            metaArtist: 'Sanatçı',
            metaAlbum: 'Albüm',
            metaGenre: 'Tür',
            viewMode: 'Görünüm',
            gridView: 'Izgara Görünümü',
            listView: 'Liste Görünümü',
            goBack: 'Geri',
            goForward: 'İleri',
            sort: 'Sırala',
            noteLabel: 'Not',
            workOrderLabel: 'İş Emri',
            musicLabel: 'Müzik',
            playlistLabel: 'Çalma Listesi',
            delete: 'Sil',
            files: 'Dosyalar',
            cancel: 'İptal',
            upload: 'Yükle',
            errorTitle: 'Hata',
            errorUpload: 'Dosya yüklenirken bir hata oluştu.',
            errorFolderCreate: 'Klasör oluşturulurken bir hata oluştu.',
            errorDelete: 'Silme işlemi sırasında bir hata oluştu.',
            errorRename: 'Yeniden adlandırma sırasında bir hata oluştu.',
            errorMove: 'Taşıma işlemi sırasında bir hata oluştu.',
            errorRestore: 'Geri yükleme sırasında bir hata oluştu.',
            errorPermanentDelete: 'Kalıcı silme sırasında bir hata oluştu.',
            detach: 'İlişkiyi Kaldır',
            detachConfirmTitle: 'İlişki Kaldırma',
            detachConfirmSingle: 'Bu dosyanın ilişkisi kaldırılacak. Dosya silinmeyecek.',
            detachConfirmMultiple: '{count} dosyanın ilişkisi kaldırılacak. Dosyalar silinmeyecek.',
            errorDetach: 'İlişki kaldırma sırasında bir hata oluştu.',
            uploadClose: 'Kapat',
            uploadCancel: 'Yüklemeyi İptal Et',
            uploadDrop: 'Bırakın',
            uploadDragFiles: 'Dosyaları sürükleyin',
            uploadOrClick: 'veya tıklayarak seçin',
            uploadDone: '{count} dosya yüklendi',
            uploadProgress: '{done}/{total} dosya yükleniyor',
            uploadFileCount: '{count} dosya',
            etaSeconds: '{n} sn kaldı',
            etaMinutes: '{n} dk kaldı',
            etaHours: '{n} sa kaldı',
            fileSelected: '1 dosya seçildi',
            selectAFile: 'Bir dosya seçin',
            manageFiles: 'Dosyaları yönetin',
            deselect: 'Seçimi Kaldır',
        },
    },
    menu: {
        dashboard: "Gösterge Paneli",
        userManagement: "Kullanıcı Yönetimi",
        userList: "Kullanıcı Listesi",
        userAdd: "Yeni Kullanıcı",
        userRoles: "Kullanıcı Rolleri",
        companyManagement: "Şirket Yönetimi",
        companyList: "Şirket Listesi",
        companyAdd: "Yeni Şirket",
        companySpecialty: "Şirket Alanları",
        ecommerceManagement: "E-Ticaret Yönetimi",
        productManagement: "Ürün Yönetimi",
        productList: "Ürün Listesi",
        productAdd: "Yeni Ürün",
        subscriptionManagement: "Abonelik Yönetimi",
        subscriptionList: "Abonelik Listesi",
        subscriptionAdd: "Yeni Abonelik",
        checkoutManagement: "Sipariş Yönetimi",
        checkoutList: "Sipariş Listesi",
        checkoutAdd: "Yeni Sipariş",
        promotionManagement: "İndirim Yönetimi",
        promotionList: "İndirim Kuponu Listesi",
        promotionAdd: "Yeni Kupon",
        paymentMethod: "Ödeme Yöntemleri",
        moduleManagement: "Modül Yönetimi",
        modules: "Modüller",

        commonManagement: "",
        vehicleBrand: "Araç Markaları",

        NOTE: 'Notlar',
        noteApp: 'Notlar',
        AGENDA: 'Ajanda',
        agendaApp: 'Ajanda',
        WEATHER: 'Hava Durumu',
        weatherPanel: 'Hava Durumu',
        FILE_MANAGER: 'Dosya Yöneticisi',
        fileManagerPanel: 'Dosya Yöneticisi',
        MUSIC: 'Müzik',
        musicPanel: 'Müzik',
    },
    pages: {
        login: {
            title: "Admin Paneli",
            cols: {
                email: "E - Posta",
                password: "Şifre"
            },
            successLogin: "Başarıyla giriş yaptınız!",
            btnText: "Giriş Yap",
            responseMessages: {
                invalidCredentials: "E - Posta veya Şifre yanlış!",
                forbiddenRequest: "Giriş işlemi başarısız. Lütfen IP adresinizin izinli olduğundan emin olunuz!"
            }
        },
        dashboard: {
            title: "Lütfen sol menüden yapmak istediğiniz işlemi seçiniz.",
            customer: {
                title: "Müşteriler",
            }
        },
        account: {
            overview: {
                title: "Profil Detayları",
                cols: {
                    name: "Ad",
                    surname: "Soyad",
                    email: "E - Posta",
                    phone: "Telefon",
                }
            },
            settings: {
                signInMethod: {
                    title: "Oturum Açma Yöntemi",
                    emailAddress: "E - Posta Adresi",
                    password: {
                        title: "Şifre",
                        cols: {
                            currentPassword: "Şuanki Şifre",
                            password: "Şifre",
                            passwordConfirmation: "Şifre Tekrar",
                        },
                        changePassword: "Şifre Değiştir",
                        updatePassword: "Şifreyi Güncelle",
                        responseMessages: {
                            currentPasswordInvalid: "Şuanki şifre geçersiz."
                        }
                    }
                }
            }
        },
        company: {
            title: "Şirketler",
            subTitle: "Şirket Listesi",
            editCompanyPattern: "Şirket Düzenle - %s",
            newCompany: "Şirket Ekle",
            cols: {
                id: "ID",
                company_type: "Şirket Türü",
                name: "Şirket İsmi",
                specialties: "Şirket Alanları",
                tax_office: "Vergi Dairesi",
                tax_number: "Vergi Numarası",
                active: "Durum",
            },
            save: {
                tabs: {
                    generalDetails: "Genel Bilgiler",
                    officer: "Çalışanlar",
                    customer: "Müşteriler",
                    module: "Modüller",
                    domain: "Domainler",
                }
            },
            officer: {
                title: "Çalışanlar",
                subTitle: "Şirkette Çalışanların Listesi",
                newOfficer: "Çalışan Ekle",
                cols: {
                    id: "ID",
                    fullName: "İsim Soyisim",
                    firstname: "İsim",
                    lastname: "Soyisim",
                    email: "E-Posta",
                    mobilePhone: "Telefon",
                    active: "Durum",
                }
            },
            customer: {
                title: "Müşteriler",
                subTitle: "Şirket Müşteri Listesi",
                cols: {
                    id: "ID",
                    fullName: "İsim Soyisim",
                    firstname: "İsim",
                    lastname: "Soyisim",
                    email: "E-Posta",
                    mobilePhone: "Telefon",
                    active: "Durum",
                }
            },
            module: {
                title: "Modüller",
                subTitle: "Şirket Modül Listesi",
                newModule: "Yeni Modül Ekle",
                editModule: "Modül Düzenle - %s",
                cols: {
                    id: "ID",
                    usage_start_date: "Kullanım Başlangıç Tarihi",
                    usage_end_date: "Kullanım Bitiş Tarihi",
                    grace_period_days: "Kapatma Süresi",
                    module_kind: "Modül Türü",
                    code: "Kod",
                    name: "Modül İsmi",
                    sort: "Sıra",
                    status: "Modül Durumu",
                },
                credentials: {
                    title: "Kimlik"
                }
            },
            domain: {
                title: "Domainler",
                subTitle: "Şirket Domain Listesi",
                newDomain: "Yeni Domain",
                editDomain: "Domain Düzenle",
                cols: {
                    id: "ID",
                    domain: "Domain",
                    isDefault: "Varsayılan",
                    active: "Durum",
                }
            },
            specialty: {
                title: "Şirket Alanları",
                subTitle: "Şirket Alanları Listesi",
                cols: {
                    id: "ID",
                    name: "Alan",
                    companiesCount: "Şirket Sayısı",
                },
            }
        },
        ecommerce: {
            product: {
                title: "Ürünler",
                subTitle: "Ürünler Listesi",
                editProduct: "Ürün Düzenle",
                editProductPattern: "Ürün Düzenle - %s",
                newProduct: "Ürün Ekle",
                cols: {
                    id: "ID",
                    name: "Ürün Adı",
                    description: "Açıklama",
                    code: "Ürün Kodu",
                    product_type: "Ürün Tipi",
                    target_type: "Hedef Kitle",
                    is_stackable: "Çoklu Satın Alım Yapılabilir Mi?",
                    active: "Durum"
                },
                save: {
                    title: "İndirim Kuponu",
                    generalCardTitle: "Genel Tanımlama",
                    newPriceCardTitle: "Fiyat Tanımlama",
                    priceCardTitle: "Tanımlı Fiyat Listesi",
                    addPriceBtn: "Fiyat Ekle",
                    no_set_price: "Bu ürün için fiyat tanımlaması yapılmamış.",
                    tabs: {
                        general: "Genel Bilgiler",
                        prices: "Fiyatlar",
                        modules: "Modüller",
                        resources: "Kaynaklar",
                        dependencies: "Bağımlılıklar",
                        upgrade_paths: "Yükseltme Yolları",
                    },
                },
                module: {
                    title: "Ürün Modülleri",
                    addBtn: "Modül Ekle",
                    newTitle: "Modül Ekle",
                    editTitle: "Modül Düzenle",
                    no_set_module: "Bu ürüne henüz modül eklenmemiş.",
                    unlimited: "Sınırsız",
                    limit_help: "Boş bırakılan limit alanları sınırsız kullanım hakkı verir.",
                    cols: {
                        module_name: "Modül",
                        daily_limit: "Günlük",
                        weekly_limit: "Haftalık",
                        monthly_limit: "Aylık",
                        yearly_limit: "Yıllık",
                    },
                },
                resource: {
                    title: "Ürün Kaynakları",
                    newTitle: "Kaynak Ekle",
                    editTitle: "Kaynak Düzenle",
                    no_set_resource: "Bu ürüne henüz kaynak eklenmemiş.",
                    cols: {
                        resource_code: "Kaynak Tipi",
                        amount: "Miktar",
                    },
                    codes: {
                        STORAGE_MB: "Depolama",
                        STOCK_ITEM_LIMIT: "Stok Kalem Limiti",
                        CUSTOM_DOMAIN: "Özel Alan Adı",
                    },
                    units: {
                        STORAGE_MB: "MB",
                        STOCK_ITEM_LIMIT: "kalem",
                        CUSTOM_DOMAIN: "adet",
                    },
                    help: {
                        STORAGE_MB: "Megabyte cinsinden depolama hakkı.",
                        STOCK_ITEM_LIMIT: "Maksimum stok kalemi sayısı.",
                        CUSTOM_DOMAIN: "Özel domain hakkı sayısı.",
                    },
                },
                dependency: {
                    required_title: "Tümü Zorunlu",
                    required_subtitle: "Aşağıdaki ürünlerin tamamı sahip olunmalı.",
                    no_required: "Zorunlu bağımlılık tanımlı değil.",
                    alternative_title: "En Az Biri",
                    alternative_subtitle: "Aşağıdaki ürünlerden en az biri sahip olunmalı.",
                    no_alternative: "Alternatif bağımlılık tanımlı değil.",
                    newRequiredTitle: "Zorunlu Bağımlılık Ekle",
                    newAlternativeTitle: "Alternatif Bağımlılık Ekle",
                    cols: {
                        product_name: "Ürün",
                    },
                },
                upgrade_path: {
                    title: "Yükseltme Yolları",
                    subtitle: "Bu paketten yükseltilebilecek diğer paketler.",
                    no_set_path: "Tanımlı yükseltme yolu yok.",
                    newTitle: "Yükseltme Yolu Ekle",
                    target_help: "Yalnızca paket tipindeki ürünler hedef olarak seçilebilir.",
                    cols: {
                        product_name: "Hedef Paket",
                    },
                },
                price: {
                    price: "Fiyat",
                    period_type: "Dönem",
                    is_recurring: "Fiyat Tipi",
                    is_recurring_recurring: "Periyodik",
                    is_recurring_oneshot: "Tek seferlik",
                    is_recurring_help: "Periyodik: müşteri her dönem (haftalık/aylık/yıllık) faturalanır, süresi dolduğunda yenilenebilir. Tek seferlik: müşteri bir kez öder, ürün süresiz aktif kalır.",
                    duplicate_period_currency: "Bu para birimi ve dönem kombinasyonu için zaten tanımlı bir fiyat var.",
                    periods: ["Haftalık", "Aylık", "3 Aylık", "6 Aylık", "Yıllık"]
                },
                types: ["Paket", "Modül", "Eklenti", "Depolama"]
            },
            promotion: {
                title: "İndirim Kuponları",
                subTitle: "İndirim Kuponları Listesi",
                editPromotion: "İndirim Kuponu Düzenle",
                editPromotionPattern: "İndirim Kuponu Düzenle - %s",
                newPromotion: "İndirim Kuponu Ekle",
                cols: {
                    id: "ID",
                    name: "Kupon Adı",
                    description: "Açıklama",
                    code: "Kupon Kodu",
                    discount_type: "İndirim Tipi",
                    discount_value: "İndirim Miktarı",
                    max_usage_count: "Kullanım Limiti",
                    max_usage_per_usable: "Kullanıcı Başına Limit",
                    usage: "Kullanılan/Limit",
                    starts_at: "Başlangıç Tarihi",
                    expires_at: "Bitiş Tarihi",
                    active: "Durum",
                    targets: "",
                    scopes: ""
                },
                save: {
                    title: "İndirim Kuponu",
                    generalCardTitle: "Genel Tanımlama",
                    maxUsableDescription: "Bir kullanıcının indirim kodunu kaç kere kullanabileceğini belirtebilirsiniz. Sınırsız olmasını istiyorsanız boş bırakın.",
                    priceCardTitle: "Fiyat Tanımlama",
                    productCardTitle: "Ürün Tanımlama",
                    productCardTitleDescription: "İndirim kuponunun geçerli olacağı ürünleri belirtebilirsiniz. Tüm ürünlerde geçerli olması için boş bırakın.",
                    companyCardTitle: "Firma Tanımlama",
                    companyCardTitleDescription: "İndirim kuponunu kullanabilecek firmaları belirtebilirsiniz. Tüm firmalar tarafından kullanılması için boş bırakın.",
                    no_selected_product: "Bu indirim kuponu için tanımlanmış ürün bulunamadı.",
                    no_selected_company: "Bu indirim kuponu için tanımlanmış firma bulunamadı.",
                }
            },
            subscription: {
                title: "Abonelikler",
                subTitle: "Abonelik Listesi",
                newSubscription: "Yeni Abonelik",
                editSubscription: "Abonelik Düzenle",
                editSubscriptionPattern: "Abonelik Düzenle - #%s",
                cols: {
                    id: "ID",
                    status: "Durum",
                    subscribable_type: "Müşteri Tipi",
                    subscribable: "Müşteri",
                    subscriber: "Müşteri",
                    product: "Ürün",
                    price: "Fiyat",
                    starts_at: "Başlangıç",
                    expires_at: "Bitiş",
                    is_trial: "Deneme",
                    trial_ends_at: "Deneme Bitiş",
                    auto_renew: "Otomatik Yenileme",
                    auto_renew_short: "Yenileme",
                    grace_period_days: "Tolerans (gün)",
                },
                expires_help: {
                    trial: "Deneme aboneliklerinde bitiş tarihi belirtilemez.",
                    oneshot: "Tek seferlik fiyatlarda bitiş tarihi belirtilemez (ürün süresiz aktif kalır).",
                },
                events: {
                    no_events: "Bu abonelik için kayıtlı olay yok.",
                    event: "Olay",
                    actor: "İşlemi Yapan",
                    types: {
                        CREATED: "Oluşturuldu",
                        ACTIVATED: "Aktifleştirildi",
                        CANCELLED: "İptal Edildi",
                        SUSPENDED: "Askıya Alındı",
                        RESUMED: "Devam Ettirildi",
                        EXTENDED: "Uzatıldı",
                        EXPIRED: "Süresi Doldu",
                        SHRUNK: "Süre Kısaltıldı",
                    },
                },
                statuses: {
                    PENDING_PAYMENT: "Ödeme Bekliyor",
                    ACTIVE: "Aktif",
                    EXPIRED: "Süresi Doldu",
                    CANCELLED: "İptal Edildi",
                    SUSPENDED: "Askıda",
                },
                actions_title: "İşlemler",
                actions: {
                    activate: "Aktifleştir",
                    cancel: "İptal Et",
                    suspend: "Askıya Al",
                    resume: "Devam Ettir",
                    extend: "Süre Uzat",
                },
                confirms: {
                    cancel: "Bu aboneliği iptal etmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
                    suspend: "Modül erişimi kesilecek. Devam etmek istediğinize emin misiniz?",
                    activate: "Aboneliği aktifleştirmek istediğinize emin misiniz?",
                    resume: "Aboneliği devam ettirmek istediğinize emin misiniz? Askıda kalan günler bitiş tarihine eklenir.",
                },
                extend: {
                    title: "Süre Uzat",
                    days_label: "Eklenecek gün sayısı",
                    days_placeholder: "Örn. 30",
                    presets: "Hızlı seçim",
                    preview_label: "Yeni bitiş tarihi",
                    trial_warning: "Bu işlem ile deneme süreniz sona erecek ve tam abonelik başlayacak.",
                    expired_warning: "Eski bitiş tarihinden ileri gidecek bir gün sayısı seçin, aksi halde abonelik tekrar süresi dolmuş olur.",
                },
                save: {
                    generalCardTitle: "Genel Tanımlama",
                    propertyCardTitle: "Ayarlar",
                    tabs: {
                        general: "Genel Bilgiler",
                        modules: "Modüller",
                        resources: "Kaynaklar",
                        events: "Olay Geçmişi",
                    },
                },
                subscribable_types: {
                    COMPANY: "Şirket",
                    CUSTOMER: "Müşteri",
                },
            },
            checkout: {
                title: "Siparişler",
                subTitle: "Sipariş Listesi",
                newOrder: "Yeni Sipariş",
                editOrder: "Sipariş Düzenle",
                editOrderPattern: "Sipariş Düzenle - #%s",
                cols: {
                    id: "ID",
                    status: "Durum",
                    order_type: "Sipariş Tipi",
                    orderable_type: "Müşteri Tipi",
                    orderable: "Müşteri",
                    customer: "Müşteri",
                    final_amount: "Tutar",
                    paid_at: "Ödeme Tarihi",
                    created_at: "Oluşturulma",
                },
                statuses: {
                    PENDING: "Bekliyor",
                    AWAITING_PAYMENT: "Ödeme Bekliyor",
                    PAID: "Ödendi",
                    FAILED: "Başarısız",
                    CANCELLED: "İptal Edildi",
                    REFUNDED: "İade Edildi",
                    PARTIALLY_PAID: "Kısmi Ödendi",
                    REFUND_REQUESTED: "İade Talep Edildi",
                },
                order_types: {
                    PURCHASE: "Satın Alım",
                    RENEWAL: "Yenileme",
                    UPGRADE: "Yükseltme",
                },
                orderable_types: {
                    COMPANY: "Şirket",
                    CUSTOMER: "Müşteri",
                },
                actions_title: "İşlemler",
                actions: {
                    confirm: "Ödeme Onayla",
                    cancel: "İptal Et",
                    request_refund: "İade Talep Et",
                    process_refund: "İade İşle",
                },
                confirms: {
                    cancel: "Bu siparişi iptal etmek istediğinize emin misiniz? Bekleyen abonelikler de iptal olacak.",
                    request_refund: "İade talebi açılacak. Gerçek iade için ardından 'İade İşle' adımı gereklidir.",
                },
                save: {
                    generalCardTitle: "Genel Tanımlama",
                    summaryCardTitle: "Sipariş Özeti",
                    overrideCardTitle: "Özel Fiyat",
                    promotionCardTitle: "Promosyon",
                    tabs: {
                        general: "Genel Bilgiler",
                        items: "Kalemler",
                        transactions: "Ödemeler",
                        promotions: "Promosyonlar",
                        notes: "Notlar",
                    },
                },
                fields: {
                    order_type_id: "Sipariş Tipi",
                    orderable_type: "Müşteri Tipi",
                    orderable_id: "Müşteri",
                    product_id: "Ürün",
                    product_price_id: "Fiyat",
                    subscription_id: "Abonelik",
                    replaces_subscription_id: "Yükseltilecek Abonelik",
                    currency_id: "Para Birimi",
                    promotion_code: "Promosyon Kodu",
                    price_override: "Özel Fiyat",
                    price_override_persistent: "Yenilemelerde de uygula",
                    price_override_help: "Bu siparişe özel fiyat tanımlar. Yenilemelerde de uygulansın istiyorsan toggle'ı aç.",
                },
                items: {
                    no_items: "Bu siparişte kalem yok.",
                    cols: {
                        title: "Ürün",
                        quantity: "Adet",
                        unit_price: "Birim Fiyat",
                        total_price: "Toplam",
                        tax_amount: "Vergi",
                    },
                },
                transactions: {
                    no_transactions: "Bu siparişe ait işlem kaydı yok.",
                    cols: {
                        type: "Tip",
                        status: "Durum",
                        payment_method: "Ödeme Yöntemi",
                        amount: "Tutar",
                        reference: "Referans",
                        created_at: "Tarih",
                    },
                    types: {
                        PAYMENT: "Ödeme",
                        REFUND: "İade",
                    },
                    statuses: {
                        PENDING: "Bekliyor",
                        PROCESSING: "İşleniyor",
                        COMPLETED: "Tamamlandı",
                        FAILED: "Başarısız",
                    },
                },
                promotions: {
                    no_promotions: "Bu siparişe uygulanmış promosyon yok.",
                    cols: {
                        code: "Kod",
                        type: "İndirim Tipi",
                        value: "İndirim",
                        amount: "Düşülen Tutar",
                    },
                },
                notes: {
                    no_notes: "Bu siparişe henüz not eklenmemiş.",
                    add_btn: "Not Ekle",
                    add_card_title: "Yeni Not",
                    placeholder: "Not yazın...",
                    actor_system: "Sistem",
                    delete_confirm: "Bu notu kalıcı olarak silmek istediğinize emin misiniz? Geri alınamaz.",
                    actor_types: {
                        ADMIN: "Yönetici",
                        SYSTEM: "Sistem",
                        CUSTOMER: "Müşteri",
                    },
                },
                confirm_modal: {
                    title: "Ödeme Onayla",
                    amount_label: "Tahsil edilen tutar",
                    amount_help: "Boş bırakırsanız kalan tutarın tamamı tahsil edilmiş sayılır.",
                    amount_fill_all: "Tümü",
                    payment_method_label: "Ödeme Yöntemi",
                    provider_reference_label: "Provider Referansı",
                    note_label: "Not",
                    paid_total_label: "Şu ana kadar tahsil edilen",
                    remaining_label: "Kalan",
                },
                refund_modal: {
                    title: "İade İşle",
                    warning: "Bu işlem geri alınamaz. Müşterinin ödediği tutar iade edilecek ve abonelik tarafı geri çekilecek.",
                    payment_method_label: "İade Yöntemi",
                    payment_method_help: "Boş bırakırsanız orijinal ödeme yöntemi kullanılır.",
                    provider_reference_label: "Provider İade Referansı",
                    note_label: "İade Notu",
                },
            }
        },
        user: {
            title: "Kullanıcılar",
            subTitle: "Kullanıcı Listesi",
            editUserPattern: "Kullanıcı Düzenle - %s",
            newUser: "Kullanıcı Ekle",
            changePassword: "Şifre Değiştir",
            cols: {
                id: "ID",
                fullName: "İsim Soyisim",
                firstname: "İsim",
                lastname: "Soyisim",
                email: "E-Posta",
                mobilePhone: "Telefon",
                role: "Kullanıcı Rolü",
                active: "Durum",
                currentPassword: "Şuanki Şifre",
                password: "Şifre",
                passwordConfirmation: "Şifre Tekrar",
            },
            role: {
                title: "Kullanıcı Rolleri",
                subTitle: "Rol Listesi",
                showUsers: "Kullanıcıları Göster",
                cols: {
                    id: "ID",
                    code: "Kod",
                    name: "Rol İsmi"
                },
            },
        },
        module: {
            title: "Modüller",
            subTitle: "Modül Listesi",
            credentials: {
                title: "Kimlik Bilgileri",
                subTitle: "%s - Kimlik Bilgileri",
            },
            settings: {
                title: "Ayarlar",
                subTitle: "%s - Ayarları",
                tooltip: {
                    enabledSms: "Müşteriye SMS gönderimini aç/kapat"
                }
            },
            AGENDA: {
                title: 'Ajanda',
                description: "Takvim tabanlı etkinlik yönetimi ile toplantılarınızı, görevlerinizi ve hatırlatıcılarınızı planlayın.",
                panel: {
                    title: 'Ajanda',
                    monthView: 'Ay',
                    dayView: 'Gün',
                    today: 'Bugün',
                    newEvent: 'Yeni',
                    refresh: 'Yenile',
                    center: 'Ortala',
                    floatingMode: 'Serbest Mod',
                    close: 'Kapat',
                    sidebar: 'Kenar çubuğu',
                    noEvents: 'Bu gün için etkinlik yok',
                    addEvent: '+ Etkinlik Ekle',
                    more: 'daha',
                    morning: 'Öğleden Önce',
                    afternoon: 'Öğleden Sonra',
                    groupByTime: 'Zamana göre grupla',
                    allDay: 'Tüm gün',
                    showShared: 'Paylaşılanlar',
                },
                form: {
                    newEvent: 'Yeni Etkinlik',
                    editEvent: 'Etkinlik Düzenle',
                    viewEvent: 'Etkinlik Detayı',
                    title: 'Başlık',
                    titlePlaceholder: 'Etkinlik başlığı',
                    description: 'Açıklama',
                    descriptionPlaceholder: 'Açıklama (opsiyonel)',
                    color: 'Renk',
                    eventDate: 'Etkinlik Tarihi',
                    eventDatePlaceholder: 'Tarih ve saat seçin',
                    reminder: 'Hatırlatıcı',
                    reminderPlaceholder: 'Opsiyonel',
                    visibility: 'Görünürlük',
                    visibilityOnlyMe: 'Sadece Ben',
                    visibilityCompany: 'Tüm Şirket',
                    visibilityGroup: {
                        company: 'Tüm Şirket',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Seçili Kişiler',
                    viewers: 'Görüntüleyiciler',
                    viewersPlaceholder: 'Kişi seçin',
                    save: 'Kaydet',
                    saving: 'Kaydediliyor...',
                    cancel: 'İptal',
                    titleRequired: 'Başlık zorunludur',
                    dateRequired: 'Etkinlik tarihi zorunludur',
                    viewerRequired: 'En az bir görüntüleyici seçmelisiniz',
                    saveError: 'Kaydetme hatası',
                    eventEndDate: 'Bitiş Tarihi',
                    eventEndDatePlaceholder: 'Opsiyonel',
                    endMustBeAfterStart: 'Bitiş tarihi başlangıçtan sonra olmalıdır',
                },
                contextMenu: {
                    edit: 'Düzenle',
                    addReminder: 'Hatırlatıcı Ekle',
                    editReminder: 'Hatırlatıcıyı Düzenle',
                    editReminders: 'Hatırlatıcıları Düzenle',
                    removeReminder: 'Hatırlatıcıyı Kaldır',
                    removeReminders: 'Hatırlatıcıları Kaldır',
                    markCompleted: 'Tamamlandı Olarak İşaretle',
                    markPending: 'Beklemede Olarak İşaretle',
                    delete: 'Sil',
                    deleteConfirm: 'Bu etkinliği silmek istediğinizden emin misiniz?',
                    deleteTitle: 'Etkinliği Sil?',
                    deleteMessage: 'Bu işlem geri alınamaz.',
                    cancel: 'Vazgeç',
                },
                reminder: {
                    add: 'Hatırlatıcı Ekle',
                    edit: 'Hatırlatıcı Düzenle',
                    addReminder: 'Yeni Hatırlatıcı Ekle',
                    typeBefore: 'Hızlı Seçim',
                    customDate: 'Özel Tarih',
                    noReminders: 'Henüz hatırlatıcı eklenmedi',
                    remove: 'Kaldır',
                    minutesBefore: '{n} dakika önce',
                    hoursBefore: '{n} saat önce',
                    daysBefore: '{n} gün önce',
                    reminders: 'Hatırlatıcılar',
                    time: 'Hatırlatıcı Zamanı',
                    timePlaceholder: 'Hatırlatıcı tarihi seçin',
                    required: 'Hatırlatıcı zamanı zorunludur',
                    mustBeFuture: 'Hatırlatıcı gelecekte olmalıdır',
                    mustBeBeforeEvent: 'Hatırlatıcı etkinlik tarihinden önce olmalıdır',
                    save: 'Kaydet',
                    cancel: 'İptal',
                },
                recurrence: {
                    title: 'Bu etkinliği tekrarla',
                    frequency: 'Sıklık',
                    every: 'Her',
                    daily: 'Gün',
                    weekly: 'Hafta',
                    monthly: 'Ay',
                    yearly: 'Yıl',
                    interval: 'Aralık',
                    endType: 'Bitiş',
                    indefinite: 'Süresiz',
                    untilDate: 'Tarihe kadar',
                    afterCount: 'Tekrar sayısı',
                    times: 'kez',
                    repeatEvery: 'Etkinlik her {freq} tekrarlanır',
                    repeatEveryN: 'Etkinlik {n} {freq} arayla tekrarlanır',
                    endNever: 'Süresiz devam eder',
                    endOnDate: '{date} tarihine kadar devam eder',
                    endAfterN: '{n} {freq} sonra sona erer',
                },
                scope: {
                    updateTitle: 'Tekrarlayan etkinliği düzenle',
                    updateMessage: 'Bu değişiklik hangi etkinliklere uygulanacak?',
                    deleteTitle: 'Tekrarlayan etkinliği sil',
                    deleteMessage: 'Hangi etkinlikler silinsin?',
                    thisOnly: 'Yalnızca Bu Etkinlik',
                    thisAndFuture: 'Bu ve Sonrakiler',
                    all: 'Tümüne',
                    realignTitle: 'Tarihler nasıl hizalansın?',
                    realignMessage: 'Diğer etkinliklerin tarih hizalamasının nasıl uygulanması gerektiğini seçin.',
                    realignShift: 'Kaydır',
                    realignShiftDesc: 'Yapılan değişiklik kadar diğer etkinlikler de kaydırılır',
                    realignAlign: 'Hizala',
                    realignAlignDesc: 'Tüm etkinlikler yeni tarihe göre hizalanır',
                },
                status: {
                    pending: 'Bekliyor',
                    completed: 'Tamamlandı',
                },
                colors: {
                    red: 'Kırmızı',
                    orange: 'Turuncu',
                    yellow: 'Sarı',
                    green: 'Yeşil',
                    blue: 'Mavi',
                    purple: 'Mor',
                    pink: 'Pembe',
                    gray: 'Gri',
                },
            },
            NOTE: {
                title: 'Notlar',
                description: "Notlarınızı kategoriler ve etiketlerle düzenleyin, paylaşın ve her cihazdan erişin.",
                sidebar: {
                    all: 'Tüm Notlar',
                    includeShared: 'Paylaşılanları dahil et',
                    sharedWithMe: 'Benimle Paylaşılanlar',
                    categories: 'Kategoriler',
                    tags: 'Etiketler',
                    colors: 'Renkler',
                    drafts: 'Taslaklar',
                    trash: 'Çöp Kutusu',
                    newCategory: 'Yeni Kategori',
                    newSubCategory: 'Yeni Alt Kategori',
                    newTag: 'Yeni Etiket',
                    categoryName: 'Kategori adı',
                    tagName: 'Etiket adı',
                    depthLimitTitle: 'Alt Kategori Limiti',
                    depthLimitAdd: 'En fazla 5 seviye alt kategori eklenebilir. Bir üst kategoriye eklemek ister misiniz?',
                    depthLimitMove: 'Toplam 5 seviye limiti aşıldığı için bu işlem tamamlanamıyor.',
                    depthLimitConfirm: 'Ekle',
                    depthLimitCancel: 'Vazgeç',
                },
                list: {
                    search: 'Notlarda ara...',
                    newNote: 'Yeni Not',
                    pinned: 'Sabitlenenler',
                    today: 'Bugün',
                    yesterday: 'Dün',
                    last7Days: 'Son 7 Gün',
                    last30Days: 'Son 30 Gün',
                    empty: 'Henüz not bulunmuyor',
                    emptyDescription: 'Yeni bir not oluşturmak için + butonuna tıklayın.',
                    sharedEmpty: 'Paylaşılan not bulunmuyor',
                    sharedEmptyDescription: 'Sizinle paylaşılan notlar burada görüntülenir.',
                    visibilityCompany: 'Şirketteki Herkes',
                    visibilityGroup: {
                        company: 'Şirketteki Herkes',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Belirli Kişiler',
                    noPreview: 'Başka Metin Yok',
                    draft: 'Taslak',
                    backToList: 'Notlar',
                    notesSelected: 'not seçildi',
                    dragToMove: 'Taşımak için kategoriye sürükleyin',
                },
                editor: {
                    emptyTitle: 'Not Seçilmedi',
                    emptyDescription: 'Bir not seçin veya yeni bir not oluşturun.',
                    color: 'Renk',
                    noColor: 'Renk Yok',
                    category: 'Kategori',
                    noCategory: 'Kategori Yok',
                    tags: 'Etiketler',
                    settings: 'Ayarlar',
                    visibility: 'Görünürlük',
                    visibilityPrivate: 'Sadece Ben',
                    visibilityCompany: 'Şirketteki Herkes',
                    visibilityGroup: {
                        company: 'Şirketteki Herkes',
                        admin: 'Tüm Yöneticiler',
                    },
                    visibilitySelected: 'Belirli Kişiler',
                    visibilityPrivateShort: 'Ben',
                    visibilityCompanyShort: 'Herkes',
                    visibilityGroupShort: {
                        company: 'Herkes',
                        admin: 'Yöneticiler',
                    },
                    visibilitySelectedShort: 'Seçilenler',
                    editPermission: 'Düzenleme Yetkisi',
                    editPermissionOwner: 'Sadece Sahip',
                    editPermissionAll: 'Tüm Görüntüleyenler',
                    editPermissionSelected: 'Belirli Düzenleyiciler',
                    editPermissionOwnerShort: 'Sahip',
                    editPermissionAllShort: 'Herkes',
                    editPermissionSelectedShort: 'Seçilenler',
                    viewers: 'Görüntüleyiciler',
                    editors: 'Düzenleyiciler',
                    revisions: 'Revizyonlar',
                    revisionDetail: 'Düzenleme Geçmişi',
                    revisionTitle: 'Başlık',
                    revisionContent: 'İçerik',
                    revisionBy: '%s tarafından',
                    save: 'Kaydet',
                    pin: 'Sabitle',
                    unpin: 'Sabitlemeyi Kaldır',
                    delete: 'Sil',
                    readOnly: 'Salt Okunur',
                    reminder: 'Ajanda',
                    reminderEventAt: 'Eklenecek Tarih',
                    reminderReminderAt: 'Hatırlatma Tarihi',
                    reminderSave: 'Ekle',
                    reminderDelete: 'Hatırlatıcıyı Kaldır',
                    reminderNoDate: 'Tarih seçiniz',
                    viewerRequired: 'Lütfen en az bir görüntüleyici seçin',
                    editorRequired: 'Lütfen en az bir düzenleyici seçin',
                    uploadingImages: 'Medyalar yükleniyor...',
                    uploadFileCount: '{completed}/{total} dosya',
                    uploadCancel: 'Yüklemeyi İptal Et',
                    uploadErrorTitle: 'Yükleme Hatası',
                    uploadErrorGeneric: 'Dosya yüklenirken bir sorun oluştu. Lütfen tekrar deneyin.',
                },
                contextMenu: {
                    pin: 'Sabitle',
                    unpin: 'Sabitlemeyi Kaldır',
                    moveTo: 'Taşı',
                    duplicate: 'Çoğalt',
                    share: 'Paylaş',
                    delete: 'Sil',
                    rename: 'Adını Değiştir',
                    newSubCategory: 'Yeni Alt Kategori',
                    changeColor: 'Renk Değiştir',
                    uncategorized: 'Kategorisiz',
                },
                trash: {
                    title: 'Çöp Kutusu',
                    empty: 'Çöp kutusu boş',
                    emptyDescription: 'Silinen notlar burada görüntülenir.',
                    restore: 'Kurtar',
                    permanentDelete: 'Kalıcı Sil',
                    permanentDeleteTitle: 'Notu Sil?',
                    permanentDeleteMessage: 'Bu işlem geri alınamaz.',
                    restoreCategoryConfirm: 'Kategoriyi de kurtarmak ister misiniz?',
                    permanentDeleteConfirm: 'Bu işlem geri alınamaz. Notu kalıcı olarak silmek istediğinize emin misiniz?',
                    deletedAt: 'Silinme: %s',
                },
                refresh: 'Yenile',
                floatingMode: 'Yüzer Mod',
                close: 'Kapat',
            }
        },
    },
    filters: {
        title: "Filtre Seçenekleri",
        user: {
            id: "ID",
            firstname: "İsim",
            lastname: "Soyisim",
            full_name: "İsim Soyisim",
            email: "E-Posta",
            mobile_phone: "Telefon",
            role: "Rol",
            active: "Durum",
        },
        company: {
            id: "ID",
            company_type: "Şirket Türü",
            name: "Şirket İsmi",
            tax_office: "Vergi Dairesi",
            tax_number: "Vergi Numarası",
            active: "Durum",
        },
        product: {
            id: "ID",
            name: "Ürün Adı",
            code: "Ürün Kodu",
            product_type_id: "Ürün Tipi",
            target_type: "Hedef Kitle",
            active: "Durum",
            with_trashed: "Silinmiş kayıtları göster",
        },
        subscription: {
            status_id: "Durum",
            subscribable_type: "Müşteri Tipi",
            subscribable_id: "Müşteri",
            product_id: "Ürün",
            is_trial: "Deneme",
            auto_renew: "Otomatik Yenileme",
        },
        checkout: {
            order_type_id: "Sipariş Tipi",
            status_id: "Durum",
            orderable_type: "Müşteri Tipi",
            orderable_id: "Müşteri",
            product_id: "Ürün",
        },
    },
    messages: {
        warning: "Uyarı",
        success: "Başarılı",
        error: "Hata",
        sureAction: "İşlemi yapmak istediğinize emin misiniz?",
        sureConfirm: "Onaylamak istediğinize emin misiniz?",
        sureDelete: "Silme işlemi yapmak istediğinize emin misiniz?",
        sureCancel: "İptal işlemi yapmak istediğinize emin misiniz?",
        actionOk: "İşleminiz başarılı bir şekilde tamamlanmıştır.",
        deleteOk: "Silme işleminiz başarılı bir şekilde tamamlanmıştır.",
        cancelOk: "İptal işleminiz başarılı bir şekilde tamamlanmıştır.",
        copyOk: "Kopyalama başarıyla tamamlanmıştır.",
        selectRow: "Lütfen bir kayıt seçiniz!",
        wait: "Lütfen Bekleyiniz!",
        loading: "Yükleniyor",
        noResultFound: "Sonuç bulunamadı!"
    },
    btn: {
        new: "Yeni",
        add: "Ekle",
        confirm: "Onayla",
        create: "Oluştur",
        copy: "Kopyala",
        edit: "Düzenle",
        delete: "Sil",
        yes: "Evet",
        no: "Hayır",
        cancel: "Vazgeç",
        close: "Kapat",
        refresh: "Yenile",
        update: "Güncelle",
        filter: "Filtrele",
        save: "Kaydet",
        saveAll: "Tümünü Kaydet",
        select: "Seç",
        selectFile: "Dosya Seç",
        upload: "Yükle",
        download: "İndir",
        action: "İşlem",
        previous: "Önceki",
        ensuing: "Sonraki",
        next: "İleri",
        back: "Geri",
        send: "Gönder",
        ok: "Tamam",
        clear: "Temizle",
        tryAgain: "Tekrar Deneyin!",
        apply: "Uygula",
        reset: "Sıfırla",
        resetChoose: "Seçimi Sıfırla",
        change: "Değiştir",
        check: "Denetle",
        remove: "Kaldır",
        selectedRowEvent: "Seçili Kayıt İşlemleri"
    },
    validation: {
        required: "Bu alan gereklidir.",
        email: "Bu alan geçerli bir e-posta olmalıdır.",
        number: "Bu alan geçerli bir sayı olmalıdır.",
        confirmed: "Bu alan onayı eşleşmiyor.",
        length: "Bu alanda 2 seçenek olmalıdır.",
        password: "Lütfen geçerli bir şifre girin.",
        passwordConfirmation: "Lütfen şifreyi tekrar girin.",
        dontMatchPassword: "Şifre alanları birbiriyle eşleşmiyor!"
    },
    customTable: {
        noData: "Listelenecek veri bulunamadı.",
        showingPageInformationPattern: "%s kayıttan, %d ile %d arası gösteriliyor",
        customPhoneInput: "Ülke Ara...",
    },
    userMenu: {
        language: "Dil",
        theme: {
            title: 'Tema',
            dark: 'Koyu Mod',
            light: 'Aydınlık Mod',
            darkSort: 'Koyu',
            lightSort: 'Aydınlık',
            midnightSort: 'Gece Yarısı',
            creamSort: 'Krem',
            system: 'Otomatik',
            themeStyle: 'Tema Stili',
        },
        layout: {
            content: {
                title: "Layout",
                default: "Sınırlı Ekran",
                fluid: "Tam Ekran",
            }
        },
        syncSettings: "Ayarları cihazlar arası senkronize et",
        accountSettings: "Hesap Ayarları",
        signOut: "Çıkış Yap"
    },
    footer: {
        copyrightText: "Tüm hakları saklıdır."
    },
    endpointActions: {
        get: "Görüntüleme",
        post: "Ekleme",
        put: "Güncelleme",
        delete: "Silme"
    },
    datepicker: {
        months: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
        monthsShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
        weekdays: ['Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct', 'Pz'],
    },
    responseErrors: {
        record_not_found: "Kayıt bulunamadı, silinmiş veya taşınmış olabilir.",
        method_not_found: "Method bulunamadı, silinmiş veya taşınmış olabilir.",
        the_discounted_price_cannot_be_higher_than_the_regular_price: "İndirimli fiyat, normal fiyattan daha büyük olamaz.",
        question_with_no_correct_answer_can_be_added: "Bu sorunun doğru cevabı belirlenmediği için sınava eklenemez!",
        provider_handler_not_found_by_code: "Koda göre sağlayıcı bulunamadı.",
        validate_error: "Doğrulama Hatası",
        delete_meeting_error: "Manuel silinmiş kayıtları silemezsiniz",
        product_code_already_exists: "Bu ürün kodu zaten kullanımda. Farklı bir kod girin.",
        invalid_target_type: "Geçersiz hedef tipi.",
        cannot_change_is_stackable_with_existing_subscriptions: "Aboneliği olan ürünün çoklu satın alım ayarını değiştiremezsiniz.",
        duplicate_product_price: "Bu para birimi ve dönem kombinasyonu için zaten bir fiyat tanımlı.",
        period_type_id_required_for_recurring: "Periyodik fiyat için dönem seçmelisiniz.",
        invalid_product_id: "Geçersiz ürün.",
        invalid_currency_id: "Geçersiz para birimi.",
        invalid_module_id: "Geçersiz modül.",
        product_module_already_exists: "Bu modül zaten ekli.",
        product_resource_already_exists: "Bu kaynak tipi zaten ekli.",
        dependency_already_exists: "Bu bağımlılık zaten tanımlı.",
        product_cannot_depend_on_itself: "Ürün kendisine bağımlı olamaz.",
        invalid_depends_on_product_id: "Bağımlı ürün bulunamadı.",
        product_cannot_upgrade_to_itself: "Ürün kendisine yükseltilemez.",
        invalid_from_product_id: "Kaynak ürün bulunamadı.",
        invalid_to_product_id: "Hedef ürün bulunamadı.",
        upgrade_path_only_between_packages: "Yükseltme yolu sadece paketler arasında tanımlanabilir.",
        upgrade_path_already_exists: "Bu yükseltme yolu zaten tanımlı.",
        invalid_status_transition: "Bu işlem mevcut abonelik durumunda yapılamaz.",
        invalid_subscribable: "Müşteri bulunamadı.",
        subscribable_type_mismatch: "Ürünün hedef kitlesi müşteri tipiyle uyuşmuyor.",
        trial_subscription_cannot_have_expires_at: "Deneme aboneliğinde bitiş tarihi belirtemezsiniz.",
        active_subscription_already_exists: "Bu müşteri için zaten aktif veya bekleyen bir abonelik var.",
        missing_product_dependencies: "Ürünün bağımlılıkları karşılanmıyor.",
        expired_subscription_cannot_change_expires_at_use_extend: "Süresi dolmuş aboneliğin bitiş tarihini doğrudan değiştiremezsiniz. 'Süre Uzat' işlemini kullanın.",
        invalid_or_inactive_product: "Ürün pasif veya bulunamıyor.",
        orderable_type_mismatch: "Ürünün hedef kitlesi müşteri tipiyle uyuşmuyor.",
        replaces_subscription_id_required: "Yükseltme için yükseltilecek abonelik seçilmelidir.",
        invalid_replaces_subscription: "Yükseltilecek abonelik bulunamadı veya aktif değil.",
        cannot_upgrade_trial_subscription: "Deneme aboneliği yükseltilemez.",
        invalid_upgrade_path: "Bu paketten seçtiğiniz pakete yükseltme tanımı yok.",
        subscription_id_required_for_renewal: "Yenileme için bir abonelik seçmelisiniz.",
        invalid_subscription_for_renewal: "Yenilenebilecek abonelik bulunamadı veya uygun durumda değil.",
        non_recurring_subscription_cannot_be_renewed: "Tek seferlik abonelikler yenilenemez.",
        product_has_no_active_price: "Üründe aktif bir fiyat tanımı yok.",
        pending_order_already_exists: "Bu müşteri ve ürün için bekleyen başka bir sipariş var.",
        old_subscription_has_no_price: "Yükseltilecek aboneliğin fiyat tanımı yok.",
        order_cannot_be_deleted_in_current_status: "Bu siparişi mevcut durumunda silemezsiniz.",
        invalid_order_status_for_payment: "Bu siparişin durumu ödeme onayına uygun değil.",
        invalid_order_status_for_cancel: "Bu siparişi mevcut durumunda iptal edemezsiniz.",
        invalid_order_status_for_refund: "İade talebi sadece ödenmiş siparişlerde açılabilir.",
        invalid_order_status_for_refund_process: "İade işlemi sadece iade talebi açılmış siparişlerde yapılabilir.",
        payment_method_id_required: "Ödeme yöntemi seçilmelidir.",
    }
};